@let isMobile = viewport().underLg;

<header
  class="flex justify-between bg-[#000A73] lg:justify-normal"
  [ngClass]="{
    'border-b-4 border-white': !header$.displayNav,
    'fixed inset-x-0 top-0 z-[110]': isMobile && mobileMenuOpen(),
  }"
  aria-label="Site header"
>
  <nav
    aria-label="Primary navigation"
    class="flex w-full items-center font-montserrat"
  >
    @if (header$.displayNav) {
      <!-- Mobile toggle -->
      <div class="flex h-[72px] w-[72px] items-center lg:hidden">
        <button
          type="button"
          (click)="mobileMenuOpen() ? closeMobileMenu() : openMobileMenu()"
          class="flex h-full w-full items-center justify-center bg-[#1E63F0]"
          [attr.aria-label]="
            mobileMenuOpen() ? 'Close navigation' : 'Open navigation'
          "
        >
          <span class="sr-only">
            {{ mobileMenuOpen() ? 'Close navigation' : 'Open navigation' }}
          </span>

          @if (mobileMenuOpen()) {
            <mat-icon class="!text-[28px] !text-white">close</mat-icon>
          } @else {
            <span
              class="block h-7 w-7 bg-[url('/assets/images/icons/stack-cb.svg')] bg-contain bg-center bg-no-repeat"
            ></span>
          }
        </button>
      </div>

      @if (mobileMenuOpen()) {
        <!-- Overlay -->
        <button
          type="button"
          class="fixed inset-0 z-[90]"
          (click)="closeMobileMenu()"
          aria-label="Close navigation overlay"
        ></button>

        <!-- NEW COMPONENT -->
        <app-mobile-nav-panel
          [rootItems]="mobileRootNav()"
          [currentItems]="mobileCurrentNav()"
          [currentTitle]="mobileNavTitle()"
          [stackDepth]="mobileNavStack().length"
          (rootSelect)="openMobileRootSection($event)"
          (itemNavigate)="onMobileNavigate($event)"
          (itemLinkNavigate)="closeMobileMenu()"
          (itemAction)="closeMobileMenu()"
          (backNav)="handleMobileBack()"
          (closeNav)="closeMobileMenu()"
        ></app-mobile-nav-panel>
      }
    }

    <!-- Logo -->
    <a
      routerLink="/dashboard"
      class="ml-6 mr-8 flex h-[72px] min-w-[90px] items-center"
      aria-label="Comcast Business"
    >
      <img
        src="/assets/images/logos/comcast_business_logo.svg"
        alt=""
        role="presentation"
        class="h-auto w-[90px]"
      />
    </a>

    <!-- Desktop Navigation -->
    @if (header$.displayNav) {
      <div class="relative flex flex-1 justify-end lg:justify-between">
        <div class="hidden lg:block">
          @if (leftNav$ | async; as navigation) {
            <ul class="flex items-center">
              @for (item of navigation; track item.label) {
                <li [isMobile]="false" [appNavigationRecord]="item"></li>
              }
            </ul>
          }
        </div>

        @if (rightNav$ | async; as rightNav) {
          <div class="flex items-center">
            <div class="group relative flex items-center">
              @let phoneNumber = '+1 (866) 892-0915';

              <a
                href="tel:{{ phoneNumber }}"
                class="flex flex-row items-center font-medium text-white focus-visible:rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                aria-label="Call customer support at {{ phoneNumber }}"
              >
                <img
                  src="/assets/images/icons/phone-cb.svg"
                  alt=""
                  aria-hidden="true"
                  class="mr-1 block h-[18px] w-[18px]"
                />
                <span class="sr-only">Call customer support: </span>
                <span class="hidden sm:flex lg:hidden xl:flex">{{
                  phoneNumber
                }}</span>
              </a>

              <div
                class="pointer-events-none absolute left-1/2 top-full z-50 mt-3 -translate-x-1/2 opacity-0 transition-all duration-200 group-hover:opacity-100"
              >
                <div
                  class="relative min-w-20 rounded-xl bg-gray-50 px-4 py-2 text-center text-sm text-black shadow-md"
                >
                  Call us
                  <div
                    class="absolute left-1/2 top-0 h-2 w-2 -translate-x-1/2 -translate-y-1/2 rotate-45 bg-gray-50"
                  ></div>
                </div>
              </div>
            </div>

            @if ((user$ | async)?.FirstName) {
              <span
                class="hidden border-[#45587B] font-semibold text-white sm:ml-6 sm:block sm:border-l-2 sm:pl-6"
                aria-live="polite"
              >
                Hello, {{ (user$ | async)?.FirstName }}
              </span>
            }

            <ul class="flex items-center">
              @for (item of rightNav; track item.label) {
                <li
                  [isMobile]="false"
                  [iconOnly]="true"
                  [appNavigationRecord]="item"
                ></li>
              }
            </ul>
          </div>
        }
      </div>
    }
  </nav>
</header>
